<template>
  <div
    class="search-total disable-font-boosting"
    :class="bem('search-total', { appearance })"
    v-html="value"
  />
</template>

<script>
import { bem } from 'src/utils/bem.js';

export default {
  name: 'SearchTotal',
  props: {
    value: String,
    appearance: {
      type: String,
      default: null,
      validator: (v) => ['search-panel', 'new-search-panel'].includes(v),
    },
  },
  methods: {
    bem,
  },
};
</script>
